import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-16" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-3xl" data-id="element-17" data-mp="pj6c83lngiqh">
        <h2 className="text-center font-display text-[1.6rem] font-black uppercase leading-tight tracking-tight text-brand sm:text-[2.2rem]" data-id="element-18" data-mp="avd0itzoq0d6">
          5 Exclusive Bonuses
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-19" data-mp="1uete2ty9cqd">
          Valued at <span className="font-bold text-ink/45" data-id="element-20" data-mp="1t3r67g5kd1d">$135</span> —
          Included{' '}
          <span className="font-bold uppercase text-lime-dark" data-id="element-21" data-mp="5xjsdvetmwa9">
            Free Today
          </span>
        </p>

        <ol className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-22" data-mp="3o3pt21d21ywx">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-start gap-4 rounded-2xl bg-white p-5 shadow-[0_1px_3px_rgba(14,42,30,0.06)]" data-id="element-23" data-mp="3t2socu38gqrp" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-black text-lime" data-id="element-24" data-mp="1r8tca6iae5dy">
                {index + 1}
              </span>
              <div data-id="element-25" data-mp="3detvgxqj2wtm">
                <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-lime-dark" data-id="element-26" data-mp="3dd91b984lfwa">
                  Bonus {index + 1}
                </p>
                <h3 className="mt-1 font-display text-sm font-black uppercase leading-snug text-brand" data-id="element-27" data-mp="3n4wmise3a0pb">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-xs text-ink/55" data-id="element-28" data-mp="2zhf07cdlfutq">{bonus.subtitle}</p>
                <p className="mt-2 text-[11px] font-bold" data-id="element-29" data-mp="2uiburqtpbml8">
                  <span className="text-ink/40 line-through" data-id="element-30" data-mp="38gikuksesiac">
                    was {bonus.was}
                  </span>{' '}
                  <span className="uppercase text-lime-dark" data-id="element-31" data-mp="33fm6teecffr7">Free</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}